import qs from 'qs';

export default {
    encode(queryObject) {
        return qs.stringify(queryObject, { arrayFormat: 'repeat'});
    },
    encodeWithBracket(queryObject) {
        return qs.stringify(queryObject, { arrayFormat: 'brackets'});
    },
    prepare(query) {
        let res = {};
        let parsedQuery = qs.parse(query, { arrayFormat: 'brackets' });

        for (const key of Object.keys(parsedQuery)) {
            res[key] = this.convert(parsedQuery[key]);
        }

        return res;
    },
    convert(value) {
        if (Array.isArray(value)) {
            return value.map(v => this.convert(v));
        }

        if (!Number.isInteger(Number(value))) {
            return value;
        }

        return parseInt(value);
    }
}


// WEBPACK FOOTER //
// ./src/services/parser/QueryString.js